import Vue from "vue";
import CompositionApi from "@vue/composition-api";
Vue.use(CompositionApi);
